import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import API_BASE_URL from '../../Config'; // Ajustá si usás otra ruta


const LiquidacionPropina = () => {
  const [propinas, setPropinas] = useState([]);
  const [pagoPropinas, setPagoPropinas] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [seleccionadas, setSeleccionadas] = useState([]);
  const [descripcion, setDescripcion] = useState('');
  const [filtro, setFiltro] = useState('false');

  useEffect(() => {
    fetchPropinas();
    fetchPagoPropinas();
  }, [filtro]);

  const fetchPropinas = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/propinas`);
      const filtradas = response.data.filter(p => String(p.estado) === filtro);
      setPropinas(filtradas);
    } catch (error) {
      console.error('Error al obtener propinas:', error);
    }
  };

  const fetchPagoPropinas = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/pagos-propina`);
      setPagoPropinas(response.data);
    } catch (error) {
      console.error('Error al obtener pagos:', error);
    }
  };

  const toggleSeleccion = (id) => {
    if (seleccionadas.includes(id)) {
      setSeleccionadas(seleccionadas.filter(sel => sel !== id));
    } else {
      setSeleccionadas([...seleccionadas, id]);
    }
  };

  const seleccionarTodas = () => {
    const visibles = propinas.filter(p => {
      const criterio = busqueda.toLowerCase();
      return (
        p.mozo?.nombre?.toLowerCase().includes(criterio) ||
        p.mozo?.ci?.includes(criterio)
      );
    });
    setSeleccionadas(visibles.map(p => p.id));
  };

  const totalSeleccionadas = propinas
    .filter(p => seleccionadas.includes(p.id))
    .reduce((sum, p) => sum + parseFloat(p.monto), 0);

  const handleLiquidar = async () => {
    if (seleccionadas.length === 0) {
      alert('Selecciona al menos una propina para liquidar.');
      return;
    }

    const seleccionadasData = propinas.filter(p => seleccionadas.includes(p.id));
    const mozosUnicos = [...new Set(seleccionadasData.map(p => p.mozo?.ci))];

    if (mozosUnicos.length > 1) {
      alert('Solo se puede liquidar propinas de un mozo a la vez.');
      return;
    }

    try {
      for (let propina of seleccionadasData) {
        // Cambiar estado a true
        await axios.put(`${API_BASE_URL}/api/propinas/${propina.id}/estado`, { estado: true });

        // Registrar en pago_propina
        await axios.post(`${API_BASE_URL}/api/pagos-propina`, {
          estado: true,
          descripcion: descripcion,
          propina: { id: propina.id }  // Estructura correcta para el backend
        });
      }

      alert('Liquidación completada.');
      setSeleccionadas([]);
      setDescripcion('');
      fetchPropinas();
      fetchPagoPropinas();
    } catch (error) {
      console.error('Error al liquidar:', error);
      alert('Error durante la liquidación.');
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Liquidación de Propinas</h2>
        <select value={filtro} onChange={(e) => setFiltro(e.target.value)} className="border p-2 rounded">
          <option value="false">Pendientes</option>
          <option value="true">Pagadas</option>
        </select>
      </div>

      <div className="mb-4">
        <Input
          placeholder="Buscar por nombre o CI del mozo..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
      </div>

      {filtro === 'false' && (
        <div className="mb-4">
          <textarea
            placeholder="Descripción o nota (opcional)"
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            className="w-full p-2 border rounded mb-2"
          />
          <Button variant="outline" onClick={seleccionarTodas} className="mr-2">
            Seleccionar todas
          </Button>
          <Button onClick={handleLiquidar}>
            Liquidar seleccionadas (Total: Gs. {totalSeleccionadas})
          </Button>
        </div>
      )}

      <table className="w-full table-auto border">
        <thead className="bg-gray-200 text-left">
          <tr>
            <th className="p-2 border">ID</th>
            <th className="p-2 border">Fecha</th>
            <th className="p-2 border">Monto</th>
            <th className="p-2 border">Mozo</th>
            {filtro === 'false' && <th className="p-2 border">Seleccionar</th>}
          </tr>
        </thead>
        <tbody>
          {propinas.filter(p => {
            const criterio = busqueda.toLowerCase();
            return (
              p.mozo?.nombre?.toLowerCase().includes(criterio) ||
              p.mozo?.ci?.includes(criterio)
            );
          }).map(p => (
            <tr key={p.id} className="hover:bg-gray-100">
              <td className="p-2 border">{p.id}</td>
              <td className="p-2 border">{p.fecha}</td>
              <td className="p-2 border">Gs. {p.monto}</td>
              <td className="p-2 border">{p.mozo?.nombre} ({p.mozo?.ci})</td>
              {filtro === 'false' && (
                <td className="p-2 border">
                  <input
                    type="checkbox"
                    checked={seleccionadas.includes(p.id)}
                    onChange={() => toggleSeleccion(p.id)}
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      {filtro === 'true' && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">Historial de Pagos</h3>
          <ul className="list-disc ml-6">
            {pagoPropinas.map(p => (
              <li key={p.id}>
                Propina ID: {p.propina?.id} - Fecha: {p.fecha} - Descripción: {p.descripcion || 'Sin nota'}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default LiquidacionPropina;
